import { useEffect, useState } from "react";

const serverUrl = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";

const LoadImage = ({ data, own }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const message = data?.message;
    if (!message || typeof message !== "string") return;

    // Chat stores image paths as "/filename" (or sometimes bare filename).
    const filename = message.replace(/^\/+/, "").trim();
    if (!filename) return;

    let objectUrl;
    let cancelled = false;

    const loadImage = async () => {
      setLoading(true);
      setFailed(false);
      setImageUrl(null);
      try {
        const res = await fetch(`${serverUrl}/image/${encodeURIComponent(filename)}`, {
          credentials: "include",
        });
        if (!res.ok) {
          throw new Error(`Image request failed (${res.status})`);
        }
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      } catch (err) {
        console.error("Failed to load image:", err);
        if (!cancelled) setFailed(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadImage();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [data.message]);

  return (
    <div
      style={{
        marginTop: 8,
        display: "flex",
        justifyContent: own ? "flex-end" : "flex-start",
        marginRight: own ? 20 : 0,
        marginLeft: own ? 0 : 20,
      }}
    >
      {loading && <div className="spinner">Loading...</div>}
      {failed && !loading && (
        <div style={{ color: "var(--chat-other-meta, var(--text-muted, #666))", fontSize: 13 }}>
          Image unavailable
        </div>
      )}
      {imageUrl && (
        <img
          src={imageUrl}
          alt="uploaded"
          style={{ maxWidth: "70%", borderRadius: "8px" }}
        />
      )}
    </div>
  );
};

export default LoadImage;
